
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.3335 7.99999C1.3335 4.31999 4.32016 1.33333 8.00016 1.33333C11.6802 1.33333 14.6668 4.31999 14.6668 7.99999C14.6668 11.68 11.6802 14.6667 8.00016 14.6667C4.32016 14.6667 1.3335 11.68 1.3335 7.99999ZM8.66683 8.66666H10.6668C11.0335 8.66666 11.3335 8.36666 11.3335 7.99999C11.3335 7.63333 11.0335 7.33333 10.6668 7.33333H8.66683V5.33333C8.66683 4.96666 8.36683 4.66666 8.00016 4.66666C7.6335 4.66666 7.3335 4.96666 7.3335 5.33333V7.33333H5.3335C4.96683 7.33333 4.66683 7.63333 4.66683 7.99999C4.66683 8.36666 4.96683 8.66666 5.3335 8.66666H7.3335V10.6667C7.3335 11.0333 7.6335 11.3333 8.00016 11.3333C8.36683 11.3333 8.66683 11.0333 8.66683 10.6667V8.66666Z" fill="#93A0AE"/>'
  }
})
